<div class="header">
  <div class="title">Edit Address</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>
<form [formGroup]="addProjectForm">
  <!-- Subject -->

  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Address</mat-label>
      <input
        matInput
        google-place
        placeholder="Address"
        [formControlName]="'street'"
        (onSelect)="setAddress($event)"
        (onSelectParts)="setAddressParts($event)"
        [autocomplete]="'off'"
      />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>City</mat-label>
      <input matInput [formControlName]="'city'" placeholder="City" />
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>State</mat-label>
      <input matInput [formControlName]="'state'" placeholder="State" />
    </mat-form-field>
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Zip</mat-label>
      <input matInput [formControlName]="'postal_code'" placeholder="Postal Code" />
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting"></div>

    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="save()">
        <span *ngIf="!addProjectForm.disabled">Save</span>
        <mat-progress-spinner
          *ngIf="addProjectForm.disabled"
          [diameter]="24"
          [mode]="'indeterminate'"
        ></mat-progress-spinner>
      </button>
    </div>
  </div>
</form>
